






































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import ECharts from 'vue-echarts'
import walden from '../../components/charts/themes/walden.json'
import {GetAssayInfosByPatientId,GetAssayDetailById,GetSimpleItemDetail} from '../../api/realTime'
@Component({
    components: {ECharts,myTable}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    dataInfo:any = {}
    activeIndex = 0
    queryform = {
        date:[new Date(new Date().setFullYear(new Date().getFullYear()-1)),new Date()],
        dateType:1
    }
    searchPopShow = false
    get height(){
        return window.innerHeight-240
    }
    list = []
    leftlist = []
    columns = [
        {title:'分组名称',key:'groupName'},
        {title:'项目代号',key:'itemCode'},
        {title:'项目名称',key:'itemName'},
        {
            title:'检查结果',
            key:'result',
            render:(h:any,p:any)=>{
                return h('div',[
                    h('span',p.row.result),
                    h('i',{
                        class:'el-icon-pie-chart',
                        style:{
                            float:'right',
                            color:'#409EFF',
                            cursor: 'pointer',
                            lineHeight:'24px'
                        },
                        on:{
                            'click':()=>{
                                this.detail(p.row)
                            }
                        }
                    })
                ]) 
            }
        },
        {title:'提示',key:'resultTips'},
        {title:'参考值',key:'reference'},
    ]
    chartShow = false
    detail(row:any){
        this.chartTitle = row.itemName
        this.chartShow = true
        this.getChartData(row)
    }
    option:any = {}
    chartTitle = ''
    async getChartData(row){
        let data = {
            patientId: this.id,
            startDate:this.formatDate(this.queryform.date[0]),
            endDate:this.formatDate(this.queryform.date[1]),
            itemCode: row.itemCode
        }
        let res = await GetSimpleItemDetail(data)
        console.log(row.itemName)
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            legend:{
                data:[row.itemName]
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data:res.data.map(v=>{return v.time}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                },
            ],
            series: [{
                type: 'line',
                name:row.itemName,
                smooth: true,
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        color: '#999999',
                    }
                },
                data:res.data.map((v:any)=>{
                    return Number(v.value)
                })
            }]
        }
    }
    created(){
        ECharts.registerTheme('ovilia-green', walden);
        this.getData()
    }
    async getData(){
        this.activeIndex = 0
        let data = {
            patientId:this.id,
            startDate:this.formatDate(this.queryform.date[0]),
            endDate:this.formatDate(this.queryform.date[1]),
            dateType:this.queryform.dateType,
        }
        let res = await GetAssayInfosByPatientId(data)
        this.leftlist = res.data
        if(res.data.length>0){
            this.getDetailData(res.data[0])
        }
    }
    activeClick(index,item){
        //节流
        if(this.activeFlag){
            this.activeIndex=index;this.getDetailData(item);
        } 
    }
    activeFlag = true
    async getDetailData(row:any){
        this.activeFlag = false
        let data = {
            PatientId:this.id,
            ReqId:row.reqId,
            AssayDate:row.assayDate,
        }
        let res = await GetAssayDetailById(data)
        this.list = res.data
        this.activeFlag = true
    }
}
